import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	ariaLabel: {
		id: 'minimizable-modal.modal-container.minimized.messaged.aria-label',
		defaultMessage: 'Minimized modal',
		description: 'Aria label for minimized modal',
	},
});
